import * as React from 'react';
import { IconMapHighway16 } from '@cian/ui-kit-design-tokens/icons';

import { TInfrastructurePoiType } from '../../../../types/infrastructure';
import { INFRASTRUCTURE_ICON_MAP } from '../../constants';
import * as styles from './styles.css';

export interface IFuturePinProps {
  /** Срок строительства — показывается в нативном тултипе пина. */
  constructionDateText: string;
  /** Тип объекта; для будущих дорог не задаётся — рисуется иконка шоссе. */
  type?: TInfrastructurePoiType;
}

/** Пин строящегося объекта или будущей дороги: зелёный круг с иконкой типа. */
export function FuturePin({ constructionDateText, type }: IFuturePinProps): React.JSX.Element {
  const Icon = type ? INFRASTRUCTURE_ICON_MAP[type] : IconMapHighway16;

  return (
    <div
      className={styles['pin']}
      data-poi-type={type ?? 'futureRoad'}
      data-testid="district-infrastructure-map-future-pin"
      title={constructionDateText}
    >
      <Icon color="icon-inverted-default" />
    </div>
  );
}
